"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScaleContext = exports.RootScalePreferenceUpdaterContext = exports.RootScalePreferenceContext = exports.RootScaleContext = exports.DEFAULT_SCALE = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
const DEFAULT_SCALE = 'large';
exports.DEFAULT_SCALE = DEFAULT_SCALE;
const ScaleContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_SCALE);
exports.ScaleContext = ScaleContext;
const RootScaleContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.RootScaleContext = RootScaleContext;
const RootScalePreferenceContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.RootScalePreferenceContext = RootScalePreferenceContext;
const RootScalePreferenceUpdaterContext = /*#__PURE__*/(0, _react.createContext)(_cdsUtils.noop);
exports.RootScalePreferenceUpdaterContext = RootScalePreferenceUpdaterContext;